module.exports = __webpack_public_path__ + "img/img_4.d0b0bbe3.png";